export default __webpack_public_path__ + "static/media/exit.07108460.svg";